// @flow
import env from '../../environment';
import {deleteCreator, getCreator, postCreator, putCreator} from '../../http';

export const endpoints = Object.freeze({
  LIST_CATEGORIES: `${env.baseApiUrl}/im/admin/category/category`,
  SORT_CATEGORIES: `${env.baseApiUrl}/im/admin/category/sort`,
  CREATE_CATEGORY: `${env.baseApiUrl}/im/admin/category/category`,
  EDIT_CATEGORY: `${env.baseApiUrl}/im/admin/category/category/:categoryId`,
  DELETE_CATEGORY: `${env.baseApiUrl}/im/admin/category/category/:categoryId`,
});

export type CategoryRequest = {
  id?: string,
  name?: string,
  portraitImage?: File,
  landscapeImage?: File,
  portraitImageId?: string,
  landscapeImageId?: string,
  enabled?: boolean,
};

export const listCategoriesApi = getCreator(endpoints.LIST_CATEGORIES);
export const createCategoryApi = postCreator(endpoints.CREATE_CATEGORY);
export const sortCategoriesApi = postCreator(endpoints.SORT_CATEGORIES);
export const editCategoryApi = putCreator(endpoints.EDIT_CATEGORY);
export const deleteCategoryApi = deleteCreator(endpoints.DELETE_CATEGORY);
